import React from 'react';
import useOutsetaAuth from '../hooks/useOutsetaAuth';
import './MembersHome.css';

const MembersHome = () => {
  const { user, openProfile } = useOutsetaAuth();
  const firstName = user && (user.given_name || user.email);

  return (
    <div className="members-page">
      <div className="container">
        <h1 className="page-title">Members area</h1>
        <p className="page-subtitle">
          {firstName ? `Welcome, ${firstName}.` : 'Welcome.'} This area is reserved for EBTA members.
        </p>

        <div className="members-notice">
          <h2>Coming soon</h2>
          <p>
            The members area is being set up. Members-only information such as documents,
            presentations and news will appear here.
          </p>
          <button type="button" className="members-profile-btn" onClick={openProfile}>
            Manage my membership
          </button>
        </div>
      </div>
    </div>
  );
};

export default MembersHome;
